export default __webpack_public_path__ + "static/media/lilitaone.regular.797856d9.ttf";